// extracted by mini-css-extract-plugin
export default {"phoneDown":"phoneDown-2653","phoneDownMobile":"phoneDownMobile-b075"};